// extracted by mini-css-extract-plugin
module.exports = {"action__div":"ThumbnailActions_action__div__2wmtE","btn__style":"ThumbnailActions_btn__style__37Bjd"};